import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AlertasComponent } from './admin/alertas/alertas.component';
import { ClientesComponent } from './admin/clientes/clientes.component';
import { ComprasAdicionalesComponent } from './admin/compras-adicionales/compras-adicionales.component';
import { DashboardComponent } from './admin/dashboard/dashboard.component';
import { DedicatoriasComponent } from './admin/dedicatorias/dedicatorias.component';
import { DetalleGrupoComponent } from './admin/detalle-grupo/detalle-grupo.component';
import { DetallePaqueteComponent } from './admin/detalle-paquete/detalle-paquete.component';
import { FlujoEfectivoComponent } from './admin/flujo-efectivo/flujo-efectivo.component';
import { FotosGruposComponent } from './admin/fotos-grupos/fotos-grupos.component';
import { GastosComponent } from './admin/gastos/gastos.component';
import { GruposComponent } from './admin/grupos/grupos.component';
import { GruposV2Component } from './admin/grupos-v2/grupos-v2.component';
import { HojaEntregaComponent } from './admin/hoja-entrega/hoja-entrega.component';
import { InicioComponent } from './admin/inicio/inicio.component';
import { InsumosComponent } from './admin/insumos/insumos.component';
import { ProveedoresComponent } from './admin/proveedores/proveedores.component';
import { ReporteGruposComponent } from './admin/reporte-grupos/reporte-grupos.component';
import { ReporteProduccionComponent } from './admin/reporte-produccion/reporte-produccion.component';
import { ReporteRegistroComponent } from './admin/reporte-registro/reporte-registro.component';
import { ReporteVentasComponent } from './admin/reporte-ventas/reporte-ventas.component';
import { UsuariosComponent } from './admin/usuarios/usuarios.component';
import { AnillosComponent } from './catalogos/anillos/anillos.component';
import { CarrerasComponent } from './catalogos/carreras/carreras.component';
import { CodigosDescuentoComponent } from './catalogos/codigos-descuento/codigos-descuento.component';
import { ColoresComponent } from './catalogos/colores/colores.component';
import { EscuelasComponent } from './catalogos/escuelas/escuelas.component';
import { EstolasComponent } from './catalogos/estolas/estolas.component';
import { FiestasComponent } from './catalogos/fiestas/fiestas.component';
import { FondosMoldurasComponent } from './catalogos/fondos-molduras/fondos-molduras.component';
import { FondosComponent } from './catalogos/fondos/fondos.component';
import { MoldurasComponent } from './catalogos/molduras/molduras.component';
import { MunicipiosComponent } from './catalogos/municipios/municipios.component';
import { PaquetesComponent } from './catalogos/paquetes/paquetes.component';
import { PlacasComponent } from './catalogos/placas/placas.component';
import { PlantillasComponent } from './catalogos/plantillas/plantillas.component';
import { PrecioAnillosComponent } from './catalogos/precio-anillos/precio-anillos.component';
import { ProductsComponent } from './catalogos/products/products.component';
import { SesionTematicaComponent } from './catalogos/sesion-tematica/sesion-tematica.component';
import { ViajesComponent } from './catalogos/viajes/viajes.component';
import { DatosComponent } from './cliente/datos/datos.component';
import { ElegirPaqueteComponent } from './cliente/elegir-paquete/elegir-paquete.component';
import { IniciarNuevoComponent } from './cliente/iniciar-nuevo/iniciar-nuevo.component';
import { IniciarSesionComponent } from './cliente/iniciar-sesion/iniciar-sesion.component';
import { MiGrupoComponent } from './cliente/mi-grupo/mi-grupo.component';
import { MisFotosComponent } from './cliente/mis-fotos/mis-fotos.component';
import { MisPagosComponent } from './cliente/mis-pagos/mis-pagos.component';
import { ObtenerContrasenaComponent } from './cliente/obtener-contrasena/obtener-contrasena.component';
import { PerfilComponent } from './cliente/perfil/perfil.component';
import { RegistrarmeComponent } from './cliente/registrarme/registrarme.component';
import { RegistroComponent } from './cliente/registro/registro.component';
import { CarrerasService } from './services/carreras.service';
import { ReporteInsumosComponent } from './admin/reporte-insumos/reporte-insumos.component';
import { ContenidoComponent } from './admin/contenido/contenido.component';
import { RegistroInternoComponent } from './admin/registro-interno/registro-interno.component';
import { CategoriasComponent } from './catalogos/categorias/categorias.component';
import { AgradecimientosComponent } from './catalogos/agradecimientos/agradecimientos.component';
import { DiplomasComponent } from './catalogos/diplomas/diplomas.component';
import { SeleccionarPaqueteComponent } from './cliente/seleccionar-paquete/seleccionar-paquete.component';
import { SeleccionarDetallesComponent } from './cliente/seleccionar-detalles/seleccionar-detalles.component';
import { SeleccionarMarcoComponent } from './cliente/seleccionar-marco/seleccionar-marco.component';
import { V2FamiliasComponent } from './admin/v2-familias/v2-familias.component';
import { V2PaquetesComponent } from './admin/v2-paquetes/v2-paquetes.component';
import { V2ProductosComponent } from './admin/v2-productos/v2-productos.component';
import { V2VariacionesComponent } from './admin/v2-variaciones/v2-variaciones.component';
import { V2inicioComponent } from './clientev2/v2inicio/v2inicio.component';
import { V2paquetesComponent } from './clientev2/v2paquetes/v2paquetes.component';
import { V2seguimientoComponent } from './clientev2/v2seguimiento/v2seguimiento.component';
import { V2procesoDemoComponent } from './clientev2/v2proceso-demo/v2proceso-demo.component';
import { RealizarPagoComponent } from './cliente/realizar-pago/realizar-pago.component';
import { PagoConfirmadoComponent } from './cliente/pago-confirmado/pago-confirmado.component';
import { FichaPagoOxxoComponent } from './cliente/ficha-pago-oxxo/ficha-pago-oxxo.component';
import { ContratoAuriComponent } from './cliente/contrato-auri/contrato-auri.component';
import { AvisoPrivacidadComponent } from './cliente/aviso-privacidad/aviso-privacidad.component';


const routes: Routes = [
  { path: '', component: InicioComponent},
  { path: 'instituciones', component: EscuelasComponent},
  { path: 'clientes', component: ClientesComponent},
  { path: 'detalle-paquete/:cliente', component: DetallePaqueteComponent},
  { path: 'detalle-grupo/:grupo', component: DetalleGrupoComponent},
  { path: 'grupos', component: GruposComponent},
  { path: 'grupos-v2', component: GruposV2Component},
  { path: 'fotos-grupos/:grupo', component: FotosGruposComponent},
  { path: 'molduras', component: MoldurasComponent},
  { path: 'dedicatorias', component: PlantillasComponent},
  { path: 'placas', component: PlacasComponent},
  { path: 'anillos', component: AnillosComponent},
  { path: 'carreras', component: CarrerasComponent},
  { path: 'fondos', component: FondosComponent},
  { path: 'sesion-tematica', component: SesionTematicaComponent},
  { path: 'estolas', component: EstolasComponent},
  { path: 'categorias', component: CategoriasComponent},
  { path: 'paquetes', component: PaquetesComponent},
  { path: 'productos', component: ProductsComponent},
  { path: 'colores', component: ColoresComponent},
  { path: 'agradecimientos', component: AgradecimientosComponent},
  { path: 'diplomas', component: DiplomasComponent},

  { path: 'contenido', component: ContenidoComponent},
  { path: 'usuarios', component: UsuariosComponent},
  { path: 'usuarios', component: UsuariosComponent},
  { path: 'viajes', component: ViajesComponent},
  { path: 'perfil', component: PerfilComponent},
  { path: 'registro/:grupo', component: RegistroComponent},
  { path: 'hoja-entrega/:grupo', component: HojaEntregaComponent},
  { path: 'perfil/datos', component: DatosComponent},
  { path: 'perfil/pagos', component: MisPagosComponent},
  { path: 'perfil/realizar-pago', component: RealizarPagoComponent},
  { path: 'perfil/pago-confirmado', component: PagoConfirmadoComponent},
  { path: 'perfil/ficha-pago-efectivo/:id', component: FichaPagoOxxoComponent},
  { path: 'contrato', component: ContratoAuriComponent},
  { path: 'aviso-de-privacidad', component: AvisoPrivacidadComponent},
  { path: 'perfil/grupo', component: MiGrupoComponent},
  { path: 'perfil/fotos', component: MisFotosComponent},
  { path: 'municipios', component: MunicipiosComponent},
  { path: 'fiestas', component: FiestasComponent},
  { path: 'precio-anillos', component: PrecioAnillosComponent},
  { path: 'codigos-descuento', component: CodigosDescuentoComponent},
  { path: 'app', component: IniciarSesionComponent},
  { path: 'obtener-contrasena', component: ObtenerContrasenaComponent},
  { path: 'fondos-molduras', component: FondosMoldurasComponent},
  { path: 'reporte-produccion', component: ReporteProduccionComponent},
  { path: 'reporte-ventas', component: ReporteVentasComponent},
  { path: 'reporte-registros', component: ReporteRegistroComponent},
  { path: 'reporte-grupos', component: ReporteGruposComponent},
  { path: 'reporte-insumos', component: ReporteInsumosComponent},
  { path: 'registrarme/:grupo', component: RegistrarmeComponent},
  { path: 'registro-interno/:grupo', component: RegistroInternoComponent},
  { path: 'elegir-paquete', component: ElegirPaqueteComponent},
  { path: 'inicio', component: IniciarNuevoComponent},
  { path: 'gastos', component: GastosComponent},
  { path: 'dashboard', component: DashboardComponent},
  { path: 'insumos', component: InsumosComponent},
  { path: 'proveedores', component: ProveedoresComponent},
  { path: 'compras-adicionales', component: ComprasAdicionalesComponent},
  { path: 'flujo-efectivo', component: FlujoEfectivoComponent},
  { path: 'alertas', component: AlertasComponent},
  { path: 'v2/familias', component: V2FamiliasComponent},
  { path: 'v2/paquetes', component: V2PaquetesComponent},
  { path: 'v2/productos', component: V2ProductosComponent},
  { path: 'v2/variaciones', component: V2VariacionesComponent},


  //Funnel Nuevo
  { path: 'seleccionar-paquete/:cliente/:grupo', component: SeleccionarPaqueteComponent},
  { path: 'seleccionar-detalles/:cliente/:grupo/:paquete', component: SeleccionarDetallesComponent},
  { path: 'seleccionar-marco/:cliente/:grupo/:paquete', component: SeleccionarMarcoComponent},

  // cliente v2

  { path: 'cliente/inicio/:grupo', component: V2inicioComponent },
  { path: 'cliente/inicio', component: V2inicioComponent },
  { path: 'cliente/login', component: V2inicioComponent },
  { path: 'cliente/paquetes', component: V2paquetesComponent },
  { path: 'cliente/proceso-v2', component: V2procesoDemoComponent },
  { path: 'cliente/realizar-pago', component: RealizarPagoComponent },
  { path: 'cliente/pago-confirmado', component: PagoConfirmadoComponent },
  { path: 'cliente/ficha-pago-efectivo/:id', component: FichaPagoOxxoComponent },
  { path: 'cliente/seguimiento', component: V2seguimientoComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
